import { Options } from '@splidejs/splide'

export type SplideI18n = NonNullable<Options['i18n']>
export type SplideI18nMap = Record<string, SplideI18n>

export const defaultCarouselSlideTypeName = 'slide'

export const carouselI18n: SplideI18nMap = {
	cs: {
		prev: 'Předchozí %name',
		next: 'Další %name',
		first: 'Přejít na první stránku %name',
		last: 'Přejít na poslední stránku %name',
		slideX: 'Přejít na %name %s',
		pageX: 'Přejít na stránku %s',
		play: 'Spustit prezentaci',
		pause: 'Pozastavit prezentaci',
		carousel: 'Karusel',
		select: 'Vyberte %name k zobrazení',
		slide: '%name',
		slideLabel: '%s z %s'
	}
}
